export default class JsonError extends Error {
  constructor() {
    super('Ошибка чтения json ответа');
    this.name = 'JsonError';
  }
}
